import React from 'react';
import './LivePageContainer.scss';
import { ILivePageContainerProps } from './ILivePageContainerProps';
import { HeaderBehavior, PageBlockTypes, WidgetType, getDefaultPageStyles } from '../SinglePageContainer/domain';
import BannerBlockPreview from 'components/PageBuilder/PageBuilderBuildingPreview/BannerBlockPreview';
import HeaderBlockPreview from 'components/PageBuilder/PageBuilderBuildingPreview/HeaderBlockPreview';
import SubtextBlockPreview from 'components/PageBuilder/PageBuilderBuildingPreview/SubtextBlockPreview';
import TextBlockPreview from 'components/PageBuilder/PageBuilderBuildingPreview/TextBlockPreview';
import ImageBlockPreview from 'components/PageBuilder/PageBuilderBuildingPreview/ImageBlockPreview';
import ImageTextBlockPreview from 'components/PageBuilder/PageBuilderBuildingPreview/ImageTextBlockPreview';
import ImageGridTextBlockPreview from 'components/PageBuilder/PageBuilderBuildingPreview/ImageGridTextBlockPreview';
import VideoBlockPreview from 'components/PageBuilder/PageBuilderBuildingPreview/VideoBlockPreview';
import ButtonBlockPreview from 'components/PageBuilder/PageBuilderBuildingPreview/ButtonBlockPreview';
import PricingBlockPreview from 'components/PageBuilder/PageBuilderBuildingPreview/PricingBlockPreview';
import CourseCurriculumBlockPreview from 'components/PageBuilder/PageBuilderBuildingPreview/CourseCurriculumBlockPreview';
import PageBuilderFooter from 'components/PageBuilder/PageBuilderFooter';
import AccessRestricted from 'containers/AccessRestricted';
import PageContainer from 'components/PageBuilder/PageBuilderBuildingPreview/BlockComponents/PageContainer';
import PageWrapper from 'components/PageBuilder/PageBuilderBuildingPreview/BlockComponents/PageWrapper';
import { useQuery } from 'react-query';
import CommunityService from 'api/react-query/services/CommunityService';
import PageBuilderService from 'api/react-query/services/PageBuilderService';
import Facebook from "Facebook";
import VideoTextBlockPreview from 'components/PageBuilder/PageBuilderBuildingPreview/VideoTextBlockPreview';
import FAQBlockPreview from 'components/PageBuilder/PageBuilderBuildingPreview/FAQBlockPreview';
import Favicon from 'react-favicon';
import PageBuilderFormPreview from 'components/PageBuilder/PageBuilderFormPreview';
import { defaultFaviconUrl } from './domain';
import PageBuilderSchedulerPreview from 'components/PageBuilder/PageBuilderBuildingPreview/PageBuilderSchedulerPreview';
import CountdownTimerBlockPreview from 'components/PageBuilder/PageBuilderBuildingPreview/CountdownTimerBlockPreview/CountdownTimerBlockPreview';
import { Helmet } from 'react-helmet-async';
import ImageTextColumnBlockPreview from 'components/PageBuilder/PageBuilderBuildingPreview/ImageTextColumnBlockPreview';
import EventBlockPreview from 'components/PageBuilder/PageBuilderBuildingPreview/EventBlockPreview';
import PageBuilderEmbedPreview from 'components/PageBuilder/PageBuilderBuildingPreview/PageBuilderEmbedPreview';
import EmbedBlockPreview from 'components/PageBuilder/PageBuilderBuildingPreview/EmbedBlockPreview';
import BannerTextColumnBlockPreview from 'components/PageBuilder/PageBuilderBuildingPreview/BannerTextColumnBlockPreview';
import FormBlockPreview from 'components/PageBuilder/PageBuilderBuildingPreview/FormBlockPreview';
import NotFoundComponentAlt from 'containers/notFound/NotFoundComponentAlt';
import TagManager from "react-gtm-module";
import PaymentBlockPreview from 'components/PageBuilder/PageBuilderBuildingPreview/PaymentBlockPreview';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Map } from "immutable";
import { AuthorizeService } from 'api/services/authorize';
import { setCookieValue } from 'utils/cookieStorage';
import { CommonConstants } from 'constants/common';
import { authorizeActions, globalActions } from 'store/actions';
import { push } from "connected-react-router";
import * as Sentry from "@sentry/react";
import jsonwebtoken from "jsonwebtoken";
import PageBuilderHeaderPreview from 'components/PageBuilder/PageBuilderBuildingPreview/PageBuilderHeaderPreview';
import PageBuilderFooterPreview from 'components/PageBuilder/PageBuilderBuildingPreview/PageBuilderFooterPreview';
import { useAtom } from 'jotai';
import { showBannerAtom } from 'showMessageMenuAtom';
import miscUtils from 'utils/miscUtils';
import useWindowSize from 'utils/windowSize';
import CoursesBlockPreview from 'components/PageBuilder/PageBuilderBuildingPreview/CoursesBlockPreview';
import PlansBlockPreview from 'components/PageBuilder/PageBuilderBuildingPreview/PlansBlockPreview';
import EventsBlockPreview from 'components/PageBuilder/PageBuilderBuildingPreview/EventsBlockPreview';

const RESPONSIVE_BREAKPOINT: number = 900;

const LivePageContainer: React.FC<ILivePageContainerProps> = (props) => {

  const windowSize = useWindowSize();

  const subdomain =
   window.location.hostname.includes("group.app") || 
   window.location.hostname.includes("group.localhost") ?
   window.location.hostname.split(".")[0] :
   window.location.hostname;

  const getCommunityQuery = useQuery(
    [CommunityService.keyIds.GET_COMMUNITY, subdomain],
    CommunityService.queryFunctions.getCommunity,
  );

  const getLivePageQuery = useQuery(
    [PageBuilderService.keyIds.GET_LIVE_PAGE, {
      groupId: getCommunityQuery. data ? getCommunityQuery.data.id : undefined,
      pageSlug: props.pageSlug ? props.pageSlug : window.location.pathname.split("/").pop(),
    }],
    (params: any) => PageBuilderService.queryFunctions.getLivePage(params, props.hideDefaultFalseParam ? '' : '?default=false'),
    {
      enabled: false,
    },
  );

  const getLivePageMetaDataQuery = useQuery(
    [PageBuilderService.keyIds.GET_LIVE_PAGE_META_DATA, {
      groupId: getCommunityQuery. data ? getCommunityQuery.data.id : undefined,
      pageSlug: props.pageSlug ? props.pageSlug : window.location.pathname.split("/").pop(),
    }],
    PageBuilderService.queryFunctions.getLivePageMetaData,
    {
      enabled: false,
    }
  );

  const [showBanner, setShowBanner] = useAtom(showBannerAtom);

  const [pageForms, setPageForms] = React.useState<Array<any>>([]);
  const [pageFormsOpenState, setPageFormsOpenState] = React.useState<any>({});
  const [pixelId, setPixelId] = React.useState<any>(null);

  React.useEffect(() => {
    if(props.hideDefaultFalseParam) {
      getLivePageMetaDataQuery.refetch();
    }
  }, [props.hideDefaultFalseParam]);

  React.useEffect(() => {
    AuthorizeService.getInstance().onAuthStateChanged(handleAuthStateChanges);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isAuthed]);

  React.useEffect(() => {
    document.body.style.overflow = 'hidden';

      return () => {
          document.body.style.overflow = 'auto';
      }
  }, []);

  React.useEffect(() => {
    if(getCommunityQuery.data) {
      if (getCommunityQuery.data.google_tag_id) {
        TagManager.initialize({ gtmId: getCommunityQuery.data.google_tag_id });
      }

      const FBpixelId = getCommunityQuery.data && getCommunityQuery.data.ex_config && getCommunityQuery.data.ex_config.facebook_pixel;
      const MetapixelId = getCommunityQuery.data && getCommunityQuery.data.ex_config && getCommunityQuery.data.ex_config.meta_pixel;

      setPixelId(FBpixelId || MetapixelId);

      document.title = getCommunityQuery.data.name;
      getLivePageQuery.refetch();
    }
  }, [getCommunityQuery.data]);

  React.useEffect(() => {
    if(getLivePageQuery.data && getLivePageQuery.data.configurations) {
      document.title = getLivePageQuery.data.title
      setPageForms(
        getLivePageQuery.data.configurations.widgets
        .map((pageForm: any) => ({
          ...pageForm.configuration,
          widget_id: pageForm.id,
          group_id: getCommunityQuery.data.id,
        }))
      );
    }
  }, [getLivePageQuery.data]);

  React.useEffect(() => {
    let nextPageFormsOpenState: any = {};

      pageForms.forEach((pageForm: any) => {
          nextPageFormsOpenState[pageForm.render_id] = 
              pageFormsOpenState[pageForm.render_id] ? 
              pageFormsOpenState[pageForm.render_id] :
              false;
      });

      setPageFormsOpenState(nextPageFormsOpenState);
  }, [pageForms.length]);

  const scrollableRef = React.useRef<any>(null);
  const element = scrollableRef.current;
  const isBannerTimingValid = miscUtils.shouldDownloadShowSmartBanner();

 React.useEffect(() => {
    const userAgent = navigator.userAgent;
    const isIOS = /iPhone|iPad|iPod/.test(userAgent) ||
      (/Macintosh/.test(userAgent) && navigator.maxTouchPoints > 1);
    const isAndroid = /Android/.test(userAgent);
    const isMobileDevice = isIOS || isAndroid;

    if (!isMobileDevice) {
      setShowBanner(false);
      return;
    }

    if (!isBannerTimingValid) {
      setShowBanner(false);
      return;
    }

    let lastScrollPosition = 0;
    let isScrollingDown = false;
    let bannerHiddenByScroll = false;

    const handleScroll = () => {
      if (!element) return;

      const currentScrollY = element.scrollTop;

      if (currentScrollY <= 0) {
        lastScrollPosition = currentScrollY;
        return;
      }

      const scrollDifference = currentScrollY - lastScrollPosition;

      if (Math.abs(scrollDifference) < 5) {
        lastScrollPosition = currentScrollY;
        return;
      }

      const isAtBottom = (element.scrollHeight - element.scrollTop) <= (element.clientHeight + 10);

      if (scrollDifference > 0) {
        // Scrolling down
        if (!isScrollingDown) {
          isScrollingDown = true;
          bannerHiddenByScroll = true;
          setShowBanner(false);
        }
      } else if (scrollDifference < 0 && !isAtBottom) {
        // Scrolling up, but not if we’re at bottom
        if (isScrollingDown && bannerHiddenByScroll) {
          isScrollingDown = false;
          setShowBanner(true);
        }
      }

      lastScrollPosition = currentScrollY;
    };

    element && element.addEventListener('scroll', handleScroll, { passive: true });
    setShowBanner(true);

    return () => {
      element && element.removeEventListener('scroll', handleScroll);
    };
  }, [element, isBannerTimingValid]);

  function handleAuthStateChanges(user: any) {
    props.hideTopLoading!();
    const query = new URLSearchParams(window.location.search);
    const t = query.get("t");
    const q = query.get("q");
    if (q && t) {
      const usr = jsonwebtoken.verify(q, 'dLS*@eP+YuGe!AzD&vUwH%Fch*$R-&mdu?9!4zRfmXrzcp8uQfjZazW3S_dE+Bw', { algorithms: ['HS256'] });
      // tslint:disable-next-line:no-parameter-reassignment
      setCookieValue(CommonConstants.USER_TOKEN, t);
      setCookieValue(CommonConstants.USER_KEY, usr);

      user = usr;
    }

    if (user) {
      if (typeof user.id !== "undefined") {
        // Identify the user
        Sentry.configureScope((scope: any) => {
          scope.setUser({ email: user.email });
        });
        // (window as any).clarity("set", "USER_EMAIL", user.email);
        // (window as any).clarity("set", "USER_NAME", user.full_name);
        // (window as any).clarity("identify", user.email);
      }
      props.login(user);
    }
  }

  const disableSearchEngineIndexing = () => {
      if(!getLivePageMetaDataQuery.data) {
        return false;
      }
      
      let search_engine_indexing = true;

      if(
        getLivePageMetaDataQuery.data.hasOwnProperty('search_engine_indexing') && getLivePageMetaDataQuery.data.search_engine_indexing !== null
      ) {
          search_engine_indexing = getLivePageMetaDataQuery.data.search_engine_indexing;
      } else {
          search_engine_indexing = getLivePageMetaDataQuery.data.group.search_engine_indexing;
      }

      return !search_engine_indexing;
  }

  const getPageBlockElements = (blockData: any) => {
    switch(blockData.type) {
      case PageBlockTypes.Banner:
        return (
          <BannerBlockPreview
          group={getCommunityQuery.data}
          blockData={blockData}
          containerBaseIdName="gp-pb-live-page-content-block-container--"
          pageStyles={getLivePageQuery.data.page_style || getDefaultPageStyles()}
          pageFormsOpenState={pageFormsOpenState}
          setPageFormsOpenState={setPageFormsOpenState}
          />
        )
      case PageBlockTypes.BannerTextColumn:
        return (
          <BannerTextColumnBlockPreview
          group={getCommunityQuery.data}
          blockData={blockData}
          containerBaseIdName="gp-pb-live-page-content-block-container--"
          pageStyles={getLivePageQuery.data.page_style || getDefaultPageStyles()}
          pageFormsOpenState={pageFormsOpenState}
          setPageFormsOpenState={setPageFormsOpenState}
          />
        )
      case PageBlockTypes.Heading:
        return (
          <HeaderBlockPreview
          blockData={blockData}
          pageStyles={getLivePageQuery.data.page_style  || getDefaultPageStyles()}
          />
        )
      case PageBlockTypes.Subtext:
        return (
          <SubtextBlockPreview
          blockData={blockData}
          pageStyles={getLivePageQuery.data.page_style  || getDefaultPageStyles()}
          />
        )
      case PageBlockTypes.Text:
        return (
          <TextBlockPreview
          blockData={blockData}
          pageStyles={getLivePageQuery.data.page_style  || getDefaultPageStyles()}
          />
        )
      case PageBlockTypes.Image:
        return (
          <ImageBlockPreview
          group={getCommunityQuery.data}
          blockData={blockData}
          pageStyles={getLivePageQuery.data.page_style  || getDefaultPageStyles()}
          containerBaseIdName="gp-pb-live-page-content-block-container--"
          pageFormsOpenState={pageFormsOpenState}
          setPageFormsOpenState={setPageFormsOpenState}
          />
        )
      case PageBlockTypes.ImageText:
        return (
          <ImageTextBlockPreview
          group={getCommunityQuery.data}
          blockData={blockData}
          containerBaseIdName="gp-pb-live-page-content-block-container--"
          pageStyles={getLivePageQuery.data.page_style  || getDefaultPageStyles()}
          pageFormsOpenState={pageFormsOpenState}
          setPageFormsOpenState={setPageFormsOpenState}
          />
        )
      case PageBlockTypes.ImageTextColumn:
        return (
          <ImageTextColumnBlockPreview
          group={getCommunityQuery.data}
          blockData={
            blockData.image_shown === undefined ? 
            {
              ...blockData,
              image_shown: true,
            } :
            blockData
          }
          containerBaseIdName="gp-pb-live-page-content-block-container--"
          pageStyles={getLivePageQuery.data.page_style  || getDefaultPageStyles()}
          pageFormsOpenState={pageFormsOpenState}
          setPageFormsOpenState={setPageFormsOpenState}
          />
        )
      case PageBlockTypes.ImageGridText:
        return (
          <ImageGridTextBlockPreview
          group={getCommunityQuery.data}
          blockData={blockData}
          containerBaseIdName="gp-pb-live-page-content-block-container--"
          pageStyles={getLivePageQuery.data.page_style  || getDefaultPageStyles()}
          pageFormsOpenState={pageFormsOpenState}
          setPageFormsOpenState={setPageFormsOpenState}
          />
        )
      case PageBlockTypes.Video:
        return (
          <VideoBlockPreview
          blockData={blockData}
          pageStyles={getLivePageQuery.data.page_style  || getDefaultPageStyles()}
          />
        )
      case PageBlockTypes.VideoText:
        return (
          <VideoTextBlockPreview
          group={getCommunityQuery.data}
          blockData={blockData}
          containerBaseIdName="gp-pb-live-page-content-block-container--"
          pageStyles={getLivePageQuery.data.page_style  || getDefaultPageStyles()}
          pageFormsOpenState={pageFormsOpenState}
          setPageFormsOpenState={setPageFormsOpenState}
          />
        )
      case PageBlockTypes.Button:
        return (
          <ButtonBlockPreview
          group={getCommunityQuery.data}
          blockData={blockData}
          containerBaseIdName="gp-pb-live-page-content-block-container--"
          pageStyles={getLivePageQuery.data.page_style  || getDefaultPageStyles()}
          pageFormsOpenState={pageFormsOpenState}
          setPageFormsOpenState={setPageFormsOpenState}
          />
        )
      case PageBlockTypes.Pricing:
        return (
          <PricingBlockPreview
          group={getCommunityQuery.data}
          blockData={blockData}
          containerBaseIdName="gp-pb-live-page-content-block-container--"
          pageStyles={getLivePageQuery.data.page_style  || getDefaultPageStyles()}
          pageFormsOpenState={pageFormsOpenState}
          setPageFormsOpenState={setPageFormsOpenState}
          />
        )
      case PageBlockTypes.Plans:
        return (
          <PlansBlockPreview
          group={getCommunityQuery.data}
          blockData={blockData}
          containerBaseIdName="gp-pb-live-page-content-block-container--"
          pageStyles={getLivePageQuery.data.page_style  || getDefaultPageStyles()}
          pageFormsOpenState={pageFormsOpenState}
          setPageFormsOpenState={setPageFormsOpenState}
          />
        )
      case PageBlockTypes.Event:
        return (
          <EventBlockPreview
          group={getCommunityQuery.data}
          blockData={blockData}
          containerBaseIdName="gp-pb-live-page-content-block-container--"
          pageStyles={getLivePageQuery.data.page_style  || getDefaultPageStyles()}
          pageFormsOpenState={pageFormsOpenState}
          setPageFormsOpenState={setPageFormsOpenState}
          />
        )
      case PageBlockTypes.Events:
        return (
          <EventsBlockPreview
          group={getCommunityQuery.data}
          blockData={blockData}
          pageStyles={getLivePageQuery.data.page_style  || getDefaultPageStyles()}
          />
        )
      case PageBlockTypes.CourseCurriculum:
        return (
          <CourseCurriculumBlockPreview
          blockData={blockData}
          pageStyles={getLivePageQuery.data.page_style  || getDefaultPageStyles()}
          />
        )
      case PageBlockTypes.Courses:
        return (
          <CoursesBlockPreview
          group={getCommunityQuery.data}
          blockData={blockData}
          containerBaseIdName="gp-pb-live-page-content-block-container--"
          pageStyles={getLivePageQuery.data.page_style  || getDefaultPageStyles()}
          pageFormsOpenState={pageFormsOpenState}
          setPageFormsOpenState={setPageFormsOpenState}
          />
        )
      case PageBlockTypes.FAQ:
        return (
          <FAQBlockPreview
          blockData={blockData}
          containerBaseIdName="gp-pb-live-page-content-block-container--"
          pageStyles={getLivePageQuery.data.page_style  || getDefaultPageStyles()}
          />
        )
      case PageBlockTypes.CountdownTimer:
        return (
          <CountdownTimerBlockPreview
          group={getCommunityQuery.data}
          buildingPreview
          blockData={blockData}
          pageStyles={getLivePageQuery.data.page_style  || getDefaultPageStyles()}
          pageBlocks={getLivePageQuery.data.configurations.configurations}
          />
        )
      case PageBlockTypes.Embed:
        return (
          <EmbedBlockPreview
          blockData={blockData}
          pageStyles={getLivePageQuery.data.page_style  || getDefaultPageStyles()}
          />
        )
      case PageBlockTypes.Form:
        return (
          <FormBlockPreview
          group={getCommunityQuery.data}
          blockData={blockData}
          pageStyles={getLivePageQuery.data.page_style  || getDefaultPageStyles()}
          />
        ) 
      case PageBlockTypes.Payment:
        return (
          <PaymentBlockPreview
          group={getCommunityQuery.data}
          refetchGroup={() => getCommunityQuery.refetch()}
          blockData={blockData}
          containerBaseIdName="gp-pb-live-page-content-block-container--"
          pageStyles={getLivePageQuery.data.page_style  || getDefaultPageStyles()}
          pageFormsOpenState={pageFormsOpenState}
          setPageFormsOpenState={setPageFormsOpenState}
          authed={props.isAuthed}
          authedUser={props.globalUser}
          />
        )
      default:
        return <></>
    }
  }

  const getLivePageElements = () => {
    if(getLivePageQuery.isLoading) {
      return <></>
    }

    if(getLivePageQuery.isError) {
      return (
        <div
        className="gp-pb-live-page-error-container"
        >
          <NotFoundComponentAlt
            group={getCommunityQuery.data}
            user
            message={<AccessRestricted
              user
              authed
              group={getCommunityQuery.data}
              message="Error 404: Page not found"
              subHeading="Please contact the website administrator"
              showActionMessage={false}
            />}
            showSubMessage={false}
          />
        </div>
      )
    }

    if(getLivePageQuery.data && !getLivePageQuery.data.configurations) {
      return (
        <div
        className="gp-pb-live-page-error-container"
        >
          <NotFoundComponentAlt
            group={getCommunityQuery.data}
            user
            message={<AccessRestricted
              user
              authed
              group={getCommunityQuery.data}
              message="This page isn’t available"
              subHeading="Admin deleted or unpublished the page."
              showActionMessage={false}
            />}
            showSubMessage={false}
          />
        </div>
      )
    }

    if(getLivePageQuery.data && getLivePageQuery.data.configurations) {
      return (
        <PageContainer
        pageStyles={getLivePageQuery.data.page_style  || getDefaultPageStyles()}
        >
        	{
				getLivePageQuery.data.header &&
				getLivePageQuery.data.header.design.header_behavior === HeaderBehavior.Sticky ? (
				<PageBuilderHeaderPreview
        group={getCommunityQuery.data}
				headerData={getLivePageQuery.data.header}
				pageStyles={getLivePageQuery.data.page_style  || getDefaultPageStyles()}
        pageFormsOpenState={pageFormsOpenState}
        setPageFormsOpenState={setPageFormsOpenState}
        containerBaseIdName="gp-pb-live-page-content-block-container--"
				/>
			) : <></>}
          <PageWrapper
            ref={scrollableRef}
			topOffset={
				getLivePageQuery.data.header &&
				getLivePageQuery.data.header.design.header_behavior === HeaderBehavior.Sticky ? 
				getLivePageQuery.data.header.design.container_height: 
				undefined
			}
          >
			{
				getLivePageQuery.data.header &&
				getLivePageQuery.data.header.design.header_behavior === HeaderBehavior.Static ? (
				<PageBuilderHeaderPreview
        group={getCommunityQuery.data}
				headerData={getLivePageQuery.data.header}
				pageStyles={getLivePageQuery.data.page_style  || getDefaultPageStyles()}
        pageFormsOpenState={pageFormsOpenState}
        setPageFormsOpenState={setPageFormsOpenState}
        containerBaseIdName="gp-pb-live-page-content-block-container--"
				/>
			) : <></>}
            {getLivePageQuery.data.configurations.configurations.map((pageBlock: any) => (
              <div
              key={pageBlock.render_id}
              id={`gp-pb-live-page-content-block-container--${pageBlock.render_id}`}
              className="gp-pb-live-page-content-block-container"
              >
                  {getPageBlockElements(pageBlock)}
              </div>
            ))}
			{getLivePageQuery.data.footer ? (
				<PageBuilderFooterPreview
        group={getCommunityQuery.data}
				footerData={getLivePageQuery.data.footer }
				pageStyles={getLivePageQuery.data.page_style  || getDefaultPageStyles()}
        pageFormsOpenState={pageFormsOpenState}
        setPageFormsOpenState={setPageFormsOpenState}
        containerBaseIdName="gp-pb-live-page-content-block-container--"
				/>
			) : <></>}
          {
            getCommunityQuery.data && 
            getCommunityQuery.data.powered_by_groupapp &&
            windowSize.width <= RESPONSIVE_BREAKPOINT ? (
                  <PageBuilderFooter
                  />
            ) : <></>
          }
          </PageWrapper>
          {
            getCommunityQuery.data && 
            getCommunityQuery.data.powered_by_groupapp &&
            windowSize.width > RESPONSIVE_BREAKPOINT ? (
                  <PageBuilderFooter
                  />
            ) : <></>
          }
          {pageForms ? pageForms.map((pageForm: any) => {
            switch(pageForm.type) {
              case WidgetType.Form:
                return (
                  <PageBuilderFormPreview
                  group={getCommunityQuery.data}
                  key={pageForm.render_id}
                  pageForm={pageForm}
                  pageFormsOpenState={pageFormsOpenState}
                  setPageFormsOpenState={setPageFormsOpenState}
                  pageStyles={getLivePageQuery.data.page_style || getDefaultPageStyles()}
                  />
                )
              case WidgetType.Scheduler:
                return (
                  <PageBuilderSchedulerPreview
                  key={pageForm.render_id}
                  pageForm={pageForm}
                  pageFormsOpenState={pageFormsOpenState}
                  setPageFormsOpenState={setPageFormsOpenState}
                  pageStyles={getLivePageQuery.data.page_style || getDefaultPageStyles()}
                  />
                )
              case WidgetType.Embed:
                return (
                  <PageBuilderEmbedPreview
                  key={pageForm.render_id}
                  pageForm={pageForm}
                  pageFormsOpenState={pageFormsOpenState}
                  setPageFormsOpenState={setPageFormsOpenState}
                  pageStyles={getLivePageQuery.data.page_style || getDefaultPageStyles()}
                  />
                )
              default:
                return <></>
            }
          }) : <></>}
        </PageContainer>
      )
    }

    return <></>
  }

  return (
    <div
    className="gp-pb-live-page-container"
    style={
      showBanner ?
      {
        paddingTop: `calc(${miscUtils.getTopOffsetForMobile('SmartAppBanner')}px + env(safe-area-inset-top))`
      } : undefined
    }
    >
        {props.hideDefaultFalseParam && disableSearchEngineIndexing() ? (
          <Helmet
          >
            <meta
            name="robots"
            content="noindex, follow"
            />
          </Helmet>
        ) : <></>}
        {(
          getCommunityQuery.data &&
          getCommunityQuery.data.favicon_image
        ) ? (
          <Favicon url={getCommunityQuery.data.favicon_image} />
        ) : (
          <Favicon url={defaultFaviconUrl}/>
        )}
        {
          pixelId ?
          <Facebook pixelId={pixelId} /> :
          <></>
        }
        {getLivePageElements()}
    </div>
  )
}

const mapDispatchToProps = (dispatch: any, ownProps: any) => {
  return {
    login: (user: any) => {
      dispatch(authorizeActions.login(user));
    },
    logout: () => {
      dispatch(authorizeActions.dbLogout());
    },
    goTo: (url: string) => dispatch(push(url)),
    hideTopLoading: () => dispatch(globalActions.hideTopLoading()),
    showMasterLoading: () => dispatch(globalActions.showMasterLoading()),
    hideMasterLoading: () => dispatch(globalActions.hideMasterLoading()),
    clearMessage: () => dispatch(globalActions.clearMessage())
  };
};

const mapStateToProps = (state: Map<string, any>) => {
  const authorize = Map(state.get("authorize", {})).toJS() as any;
  const globalUser: any = state.getIn(["authorize", "user"]);

  return {
    globalUser,
    isAuthed: authorize.authed
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LivePageContainer as any) as any
) as any;